import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-obs",
  "use": "icon-nav-obs-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-nav-obs\">\r\n<path d=\"M178.4,147.7v-42c0-3-2.4-5.4-5.8-5.4h-67.2l0.5-35.7h41.3c6.4,0,11.5-5.2,11.5-11.6V11.7c0-6.4-5.1-11.6-11.5-11.6H52.9\r\n\tc-6.4,0-11.5,5.2-11.5,11.6V53c0,6.4,5.1,11.6,11.5,11.6h41.3l0.5,35.7H27.4c-3.5,0-5.8,2.4-5.8,5.4v0.5v42l-11.1-0.5\r\n\tC4.7,147.7,0,152.5,0,158.4v30.9c0,5.9,4.7,10.7,10.6,10.7h33.2c5.9,0,10.6-4.8,10.5-10.7v-30.9c0-5.9-4.7-10.7-10.5-10.7H33.3\r\n\tv-35.6h60.9v35.6H83.4c-5.8,0-10.6,4.8-10.6,10.7v30.9c0,5.9,4.7,10.7,10.6,10.7h33.2c5.8,0,10.5-4.8,10.6-10.7v-30.9\r\n\tc0-5.9-4.7-10.7-10.5-10.7h-10.8v-35.6h60.9v35.6h-10.5c-5.8,0-10.5,4.8-10.5,10.7v30.9c0,5.9,4.7,10.7,10.5,10.7h33.2\r\n\tc5.8,0,10.5-4.8,10.5-10.7v-30.9c0-5.9-4.7-10.7-10.6-10.7H178.4L178.4,147.7z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/nav/nav-obs.svg
// module id = WN5I
// module chunks = 13